<template>
  <div class="container-fluid">
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Listado de órdenes de pago</h1>
          <p class="view-header__subtitle">Órdenes de pago a proveedores, con búsqueda y filtros.</p>
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__section-title">
          <i class="bi bi-funnel"></i>
          Filtros
        </div>
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="filters.qprovider" type="search" class="form-control" placeholder="Buscar por proveedor...">
          </div>
          <div class="filters-panel__field">
            <input v-model="filters.quser" type="search" class="form-control" placeholder="Buscar por usuario...">
          </div>
          <div class="filters-panel__field">
            <input v-model="filters.qnumber" type="search" class="form-control" placeholder="Buscar por nro. de orden...">
          </div>
          <div class="filters-panel__field filters-panel__field--inline">
            <label class="control-label">Fecha:</label>
            <Daterange :key="daterangeKey" :opendir="'left'" :filtered="true" @datepicked="dateCreated"/>
          </div>
          <div class="filters-panel__actions">
            <button type="button" class="filters-panel__btn filters-panel__btn--outline" @click="clearFilters">
              <i class="bi bi-eraser"></i>
              Limpiar todo
            </button>
            <button type="button" class="filters-panel__btn" @click="exportCSV">
              <i class="bi bi-filetype-csv"></i>
              Exportar CSV
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
      />
    </div>
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import formatDateMixin from "../../mixins/formatDateMixin";
import formatMoneyMixin from "../../mixins/formatMoneyMixin";
import Daterange from "../global/Daterange-component.vue";

export default {
  components: {
    VdtnetTable,
    Daterange,
  },
  mixins: [formatDateMixin, formatMoneyMixin],
  data() {
    return {
      suppressReload: false,
      daterangeKey: 0,
      filters: {
        qclient: '',
        qprovider: '',
        quser: '',
        qnumber: '',
        fromDate: null,
        toDate: null,
      },
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/payments/index",
          type: "GET",
          data: (d) => {
            d.filters = this.filters;
            return d;
          },
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        processing: true,
        pageLength: 15,
        searching: true,
        searchDelay: 400,
        destroy: true,
        order: [[0, 'desc']],
        ordering: true,
        lengthChange: true,
        serverSide: true,
        autoWidth: false,
      },
      fields: {
        date: {
          label: "Fecha",
          searchable: true,
          render: (data) => this.formatoFechaHora(data),
        },
        number: { label: "Número", searchable: true },
        provider: {
          label: "Proveedor",
          searchable: true,
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data || ''}</span>` : data,
        },
        user: { label: "Usuario", searchable: true },
        paid: { label: "Método de pago", searchable: false, orderable: false },
        total: {
          label: "Total",
          searchable: true,
          align: "right",
          render: this.formatoDinamicoMoneda,
        },
      },
    };
  },
  watch: {
    'filters.qprovider'() { this.debouncedRefresh(); },
    'filters.quser'() { this.debouncedRefresh(); },
    'filters.qnumber'() { this.debouncedRefresh(); },
  },
  mounted() {
    this.setDefaultDateRange();
  },
  methods: {
    refreshTable() {
      if (this.suppressReload) return;
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    clearFilters() {
      clearTimeout(this._refreshTimer);
      this.suppressReload = true;
      this.filters.qprovider = '';
      this.filters.quser = '';
      this.filters.qnumber = '';
      // Resetea la fecha al rango por defecto (ultimos 30 dias) en data y en el
      // picker (via key), para que "Limpiar todo" realmente limpie todo.
      this.setDefaultDateRange();
      this.daterangeKey++;
      this.$nextTick(() => {
        this.suppressReload = false;
        this.refreshTable();
      });
    },
    debouncedRefresh() {
      clearTimeout(this._refreshTimer);
      this._refreshTimer = setTimeout(() => this.refreshTable(), 500);
    },
    dateCreated(date) {
      this.filters.fromDate = date.startDate;
      this.filters.toDate = date.endDate;
      this.refreshTable();
    },
    setDefaultDateRange() {
      const today = new Date();
      const startDate = new Date();
      startDate.setDate(today.getDate() - 30);
      this.filters.fromDate = this.formatDate(startDate);
      this.filters.toDate = this.formatDate(today);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${day}/${month}/${year}`;
    },
    exportCSV() {
      this.$http.post("/api/reports/CSVpayorderList", this.filters);
    },
  },
};
</script>

<style scoped>
.filters-panel__field--inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filters-panel__field--inline .control-label {
  margin: 0;
  white-space: nowrap;
  font-size: 13px;
  color: var(--text);
}

.filters-panel__field--inline > .form-group {
  flex: 1 1 auto;
  margin-bottom: 0;
}
</style>
